var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loader'):(_vm.hasMortgageAlternatives)?_c('mortgage-alternatives-page'):(_vm.mortgageFromCashflow)?_c('no-mortgage-data-alternatives-page'):_c('no-mortgage-page')
}
var staticRenderFns = []

export { render, staticRenderFns }